import { PortletStoreApi } from '../App';
import type { at } from '../generated/Beans';
import { AzureCallStrategy } from './azurecallstrategy';
import { JistiCallStrategy } from './jitsicallstrategy';
import type {
  CallInfoStateCallback,
  CallMenuInterface
} from 'virtual-visit-common';
type AzureSocketDataBeanConfig = at.sense.portlets.saf.virtualvisitpatient.model.AzureSocketDataBeanConfig;
type JitsiSocketDataBeanConfig = at.sense.portlets.saf.virtualvisitpatient.model.JitsiSocketDataBeanConfig;
type SocketDataBean = at.sense.portlets.saf.virtualvisitpatient.model.SocketDataBean;

export type CallStrategyConfig =
  | AzureSocketDataBeanConfig
  | JitsiSocketDataBeanConfig;

export type CallStatusMessageListener = (msg: string) => void;

export interface CallStrategy {
  initProviderAndStartCall: (
    config: CallStrategyConfig,
    onReadyToClose?: () => void,
    physicianLeftMessageDelay?: number,
    participantName?: string,
    callInfoStateCallback?: CallInfoStateCallback,
    camName?: string
  ) => Promise<void>;

  stopCall: () => Promise<void>;
  getCallStrategyConfig: (data: SocketDataBean) => CallStrategyConfig;
  setPreventPhysicianLeftNotification: (prevent: boolean) => void;
  addCallStatusMessageListener: (lst: CallStatusMessageListener) => void;
  getCallMenuInterface: () => CallMenuInterface | undefined;
}

let callStrategy: CallStrategy | undefined;
export function getCallStrategy(): CallStrategy {
  if (!callStrategy) {
    if (PortletStoreApi.getState().configuration.videoProvider === 'AZURE') {
      callStrategy = new AzureCallStrategy();
    } else {
      callStrategy = new JistiCallStrategy();
    }
  }
  return callStrategy;
}
